import Wishlist from "../components/wishlist/Wishlist.jsx";
const WishlistPage = () => {
  return (
    <div>
      <Wishlist />
    </div>
  );
};

export default WishlistPage;
